import { render, staticRenderFns } from "./fenxiao_center.vue?vue&type=template&id=65f2f306&scoped=true"
import script from "./fenxiao_center.vue?vue&type=script&lang=js"
export * from "./fenxiao_center.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_center.vue?vue&type=style&index=0&id=65f2f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f2f306",
  null
  
)

export default component.exports